/** @jsx jsx */
import PropTypes from "prop-types";
import { Flex, jsx } from "theme-ui";
import DatePicker from "react-datepicker";
import { parseISO, format } from "date-fns";
import { noop } from "../../../utils/lodash";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";

const Date = ({ onChange, renderPrint, value, maxDate, ...props }) => {
  const parsedValue = value ? parseISO(value) : null;
  const displayValue = parsedValue
    ? format(parsedValue, "EEE MMM dd yyyy")
    : "";
  const handleChange = (date) => {
    if (!date) return;
    date.setHours(12);
    const formattedDate = date?.toISOString().split("T")[0];
    onChange({ target: { value: formattedDate } });
  };

  const flexStyles = {
    sx: {
      width: "100%",
      outline: "0 !important",
      borderRadius: 0,
      ".form-control:focus": {
        boxShadow: "unset",
      },
      "div, input": {
        borderRadius: 0,
      },
      border: "1px solid transparent",
      borderColor: "#605E5C",
    },
  };

  if (renderPrint) {
    return renderPrint(value);
  }

  return (
    <Flex {...flexStyles}>
      <DatePicker
        selected={parsedValue}
        onChange={handleChange}
        maxDate={maxDate ? parseISO(maxDate) : null}
        dateFormat="EEE MMM dd yyyy"
        placeholderText="Please select a date"
        className="custom-date-input"
        wrapperClassName="date-picker-wrapper"
        popperPlacement="bottom-start"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        onKeyDown={(e) => e.preventDefault()}
        onFocus={(e) => e.target.blur()}
        value={displayValue}
        {...props}
        style={{ width: "100%", cursor: "pointer" }}
      />
    </Flex>
  );
};

Date.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  maxDate: PropTypes.string,
  renderPrint: PropTypes.func,
};

Date.defaultProps = {
  onChange: noop,
  value: "",
  maxDate: "",
  renderPrint: null,
};

export default Date;